import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { BaseModalPageComponent } from '../../base-modal.component';
import { Location } from '@angular/common';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { DiscussionPluginService } from './discussion-plugin.service';
import { ModalComponent } from '../../modal/modal.component';
import { ConfirmComponent } from '../../modal/confirm.component';
import { BasePluginMenuComponent, EditDiscussionMenuComponent } from '../../menus/index';
import { UntypedFormGroup } from '@angular/forms';
import { PeopleService } from '../../shared/services';
import * as _ from 'lodash';

@Component({
    selector: 'discussion-edit',
    templateUrl: './discussion-edit.component.html',
    standalone: false
})
export class DiscussionEditPageComponent extends BaseModalPageComponent implements OnInit {
  public actionPlanId: string;
  public actionPlanItemId: string;
  public pluginId: string;
  public commentId: string;
  public plugin: any;
  public comment: string;
  public type: number;
  public processing = false;
  public isEditPage = false;
  editForm: UntypedFormGroup;
  public types: any;

  public get menuComponent() {
    return this.isEditPage ? EditDiscussionMenuComponent : BasePluginMenuComponent;
  }

  @ViewChild('menuModal', { static: true })
  menuModal: ModalComponent;
  @ViewChild('deleteConfirm', { static: true })
  deleteConfirm: ConfirmComponent;
  @ViewChild('deleteCommentConfirm', { static: true })
  deleteCommentConfirm: ConfirmComponent;
  @ViewChild('typesModal', { static: true })
  typeModal: ModalComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private service: DiscussionPluginService,
    private router: Router,
    location: Location,
    private cdf: ChangeDetectorRef,
    private peopleService: PeopleService
  ) {
    super(location);
  }

  ngOnInit() {
    this.isEditPage = this.router.url.includes('edit');
    this.peopleService.getCurrent().subscribe((data) => (this.currentPerson = data));
    this.activatedRoute.params.subscribe((params: Params) => {
      const id = params['actionPlanId'];
      if (id == null) this.router.navigate([this.inspectionsRoute]);

      this.actionPlanId = id;

      const actionPlanItemId = params['actionPlanItemId'];
      if (actionPlanItemId == null) this.router.navigate([this.inspectionsRoute, this.actionPlanId]);

      this.actionPlanItemId = actionPlanItemId;

      const pluginId = params['pluginId'];
      if (pluginId == null) this.goToBack();

      this.pluginId = pluginId;

      const commentId = params['commentId'];
      if (commentId == null && this.isEditPage) this.goToBack();

      this.commentId = commentId;
      this.editForm = new UntypedFormGroup({});

      this.initData();
    });
  }

  initData() {
    this.types = _.orderBy(this.service.getTypes(), ['label']);
    this.service.getPlugin(this.actionPlanId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      const comments = this.plugin.config.Comments;
      const comment = comments ? comments.find((c) => c.Id === this.commentId) : null;
      if (this.isEditPage && this.currentPerson.id !== comment.Writter) {
        this.goToBack();
      }

      const regex = new RegExp(/<br\s*[\/]?>/gi);

      this.comment = comment ? comment.Comment.replace(regex, '\n') : '';
      this.type = comment ? comment.Type : -1;
      this.cdf.detectChanges();
    });
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      default:
    }
  }

  save() {
    this.processing = true;
    if (this.isEditPage) {
      this.service
        .editComment(this.actionPlanId, this.actionPlanItemId, this.pluginId, this.commentId, this.comment, this.type)
        .subscribe((data) => {
          this.processing = false;
          this.goToBack();
        });
    } else {
      this.service
        .addComment(this.actionPlanId, this.actionPlanItemId, this.pluginId, this.comment, this.type)
        .subscribe((data) => {
          this.processing = false;
          this.goToBack();
        });
    }
  }

  cancel() {
    this.goToBack();
  }

  openDeleteConfirm() {
    this.isEditPage ? this.deleteCommentConfirm.open() : this.deleteConfirm.open();
  }

  deleteComment(e: any) {
    this.service
      .deleteComment(this.actionPlanId, this.actionPlanItemId, this.pluginId, this.commentId)
      .subscribe((success: boolean) => {
        this.goToBack();
      });
  }

  deletePlugin(e: any) {
    this.service.deletePlugin(this.actionPlanId, this.actionPlanItemId, this.pluginId).subscribe((success: boolean) => {
      if (success) {
        this.goToBack();
      }
    });
  }

  public openTypesSelector(selectedIndex: number): void {
    this.openSelector(this.typeModal, this.types, this.type);
  }

  public selectTypesMenu(item: any) {
    const selectedIndex = this.type === item.selectedIndex ? -1 : item.selectedIndex;
    this.type = selectedIndex;
  }

  public onClose(e: any) {}
}
